import { EntityCommand, EntityCommandPropertyValues, EntityCommandTypeEnum, IEntityCommand } from "@seriously-rad/seriouslyrad-framework-core/EntityCommand";
import { EntityCommandInformation } from "@seriously-rad/seriouslyrad-framework-core/EntityCommandInformation";
import { PartialNullable } from "@seriously-rad/seriouslyrad-framework-core/Extensions";
import { Property } from "@seriously-rad/seriouslyrad-framework-core/RadObject";
import { PermissionEvaluator } from "@seriously-rad/seriouslyrad-framework-core/Server/DotNet/SeriouslyRAD.Framework.Data.Entities/Evaluation/Evaluators/PermissionEvaluator";
import { DialogResultEnum } from "@seriously-rad/seriouslyrad-framework-core/Ui/Dialogs/DialogResultEnum";
import { PageManager } from "@seriously-rad/seriouslyrad-framework-core/Ui/PageManager";
import { OfficerRequestImportDialog } from "../Ui/Dialogs/OfficerRequestImportDialog";
import { NAMESPACE } from "./_Namespace";

export type EntityCommandOfficerRequestNewFromEmailTextPropertyValues =
    EntityCommandPropertyValues
    & {
    };

export type EntityCommandOfficerRequestNewFromEmailTextProperties = {
    [name in keyof EntityCommandOfficerRequestNewFromEmailTextPropertyValues]: Property<EntityCommandOfficerRequestNewFromEmailTextPropertyValues[name]>
};

export interface IEntityCommandOfficerRequestNewFromEmailText extends IEntityCommand, EntityCommandOfficerRequestNewFromEmailTextProperties
{
}

export class EntityCommandOfficerRequestNewFromEmailText extends EntityCommand implements IEntityCommandOfficerRequestNewFromEmailText
{
    // #region Static

    // #region Properties

    public static override classNamespace = NAMESPACE + "EntityCommandOfficerRequestNewFromEmailText";
    public static override className = "EntityCommandOfficerRequestNewFromEmailText";

    // #endregion

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<EntityCommandOfficerRequestNewFromEmailTextPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                description: "New from Email",
                entityName: "OfficerRequest",
                key: "OFFICERREQUEST_NEW_FROM_EMAIL_TEXT",
                permission: PermissionEvaluator.permissionLevels.create,
                type: EntityCommandTypeEnum.entitySet,
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Global Variables

    protected officerRequestImportDialog?: OfficerRequestImportDialog;

    // #endregion

    // #region Constructors

    constructor(propertyValues?: PartialNullable<EntityCommandOfficerRequestNewFromEmailTextPropertyValues>)
    {
        super(propertyValues);
    }

    // #endregion

    // #region Overrides

    protected override async _executeAsync(entityCommandInformation: EntityCommandInformation, value?: any)
    {
        await super._executeAsync(entityCommandInformation, value);

        if (!this.officerRequestImportDialog)
            this.officerRequestImportDialog = new OfficerRequestImportDialog();

        const
            response = await this.officerRequestImportDialog.openAsync();

        if (response.dialogResult !== DialogResultEnum.ok)
            return;

        await PageManager.instance?.navigateAsync("/officerrequests/new/", false, false, { newRecord: response.promiseData });
    }

    // #endregion

    // #endregion
}

